












import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import { TreeItem } from '../model/filetree'

@Component({
  name: 'FileTreeNode'
})
export default class FileTreeNode extends Vue {
  @Prop() item!: TreeItem

  _opened = false

  get opened () {
    return this.item.type === 'root' || this._opened
  }

  @Emit('change') childChange (cur: string) {
    if (this.item.type !== 'root') {
      return this.item.name + '/' + cur
    } else {
      return cur
    }
  }

  click (event: MouseEvent) {
    if (this.item.type === 'dir') {
      this._opened = !this._opened
    } else if (this.item.type === 'file') {
      this.$emit('change', this.item.name)
    }

    event.stopPropagation()
  }
}
